<template>
  <v-dialog max-width="500" v-model="dialog" hide-overlay>
    <v-card class="white" v-if="message">
      <v-form ref="form">
        <v-card-title>
          <div class="text-truncate dialog-title">{{ $t('support_request') }}</div>
          <v-spacer></v-spacer>
          <v-btn :disabled="loading" :small="$vuetify.breakpoint.xsOnly" icon @click="closeDialog">
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <div class="mt-2">{{ $t('support_request_help') }}</div>
          <div :class="$vuetify.breakpoint.xsOnly ? 'caption' : ''" class="my-5">
            {{ $t('required_fields_are_marked_with_asterisk') }} (<span class="red--text">*</span>).
          </div>
          <v-text-field :rules="[$rules.required]" class="required" v-model="name" :label="$t('your_name')"></v-text-field>
          <v-text-field :rules="[$rules.required, $rules.email]" class="required" v-model="email" :label="$t('your_email')"></v-text-field>
          <v-textarea v-model="details" rows="3" :label="$t('tell_us_about_your_issue')"></v-textarea>
          <v-alert text :value="error" type="error">
            {{ $t('error_sending_support_ticket') }}
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="loading" text small @click="closeDialog()">{{ $t('dont_send') }}</v-btn>
          <v-btn :loading="loading" color="primary" small @click="sendSupportTicket()">{{ $t('send') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import chatApi from "@/api/chat-api";

export default {
  name: 'SupportTicketDialog',
  data() {
    return {
      dialog: false,
      message: null,
      loading: false,
      error: false,
      name: '',
      email: '',
      details: '',
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.message = null;
        this.error = false;
        this.name = '';
        this.email = '';
        this.details = '';

      }
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    open(message) {
      this.message = message;
      this.dialog = true;
    },
    async sendSupportTicket() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.error = false;

      try {
        const message = await chatApi.postSupportTicket(this.message, {
          name: this.name,
          email: this.email,
          message: this.details,
        });
        this.$emit('ticket-created', message);
        this.dialog = false;
      } catch (error) {
        console.error(error);
        this.error = true;
      }
      this.loading = false;
    }
  }
}

</script>


<style scoped lang="scss">

</style>
